import { GradientButton, OutlinedButton } from '@src/components/reusable';
import { useTranslate, useWidgetsTheme } from '@src/core/hooks';
import { IconCheck, IconX } from '@tabler/icons-react';
import React from 'react';
import { Actions, Container, Description } from './styles';
import Modal from '@src/components/ui2/Modal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ProductPackageCancelModal = (props: Readonly<Props>) => {
  const { isOpen, onClose, onConfirm } = props;

  const { i18n } = useTranslate();
  const actionColor = useWidgetsTheme('actionColor');

  return (
    <Modal
      onClose={onClose}
      open={isOpen}
      title={i18n('product_package_cancel_modal_title')}
      width={402}
      slots={{
        Content: Container,
      }}
    >
      <Description>
        <p>{i18n('product_package_cancel_modal_description')}</p>
      </Description>

      <Actions>
        <OutlinedButton color={actionColor} onClick={onClose}>
          <IconX size={20} />
          {i18n('product_package_cancel_modal_action_no')}
        </OutlinedButton>

        <GradientButton fullWidth={false} actionColor={actionColor} onClick={onConfirm}>
          <IconCheck size={20} />
          {i18n('product_package_cancel_modal_action_yes')}
        </GradientButton>
      </Actions>
    </Modal>
  );
};

export default ProductPackageCancelModal;
